import React from 'react';
import AppRouter from './router/AppRouter';
import { ProjectProvider } from './context/ProjectContext';
import { ServiceStatusProvider } from './context/ServiceStatusContext';
import ServiceDownBanner from './components/ServiceDownBanner';
import ImageRateLimitBanner from './components/ImageRateLimitBanner';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  return (
    <ServiceStatusProvider>
      <ProjectProvider>
        {/* Global toast container — only one per app */}
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        {/* Add the image rate limit banner */}
        <ImageRateLimitBanner />
        
        {/* Existing global UI */}
        <ServiceDownBanner />
        <AppRouter />
      </ProjectProvider>
    </ServiceStatusProvider>
  );
};

export default App;


